import qs from 'qs'
import { http } from '@ud/admin-framework'

interface AuthParams {
  /** 当前操作权限 */
  customId: string
  /** 当前导出地址 */
  url: string
  /** 导出参数 */
  exportParams?: any
}

function fileExport(data: AuthParams) {
  const authParams = {
    appCode: 'uaa',
    customId: data.customId,
  }
  http.post('/my/getTokenByCustomId', authParams).then(res => {
    console.log(res,'res-----muee')
    const params = {
      otp: res.data,
      ...data.exportParams
    }
    window.open(http.defaults.baseURL + data.url + '?' + qs.stringify(params))
  })
}
export { fileExport }